import { EffectComposer, Bloom } from "@react-three/postprocessing";
import { useGpuTier } from "../../hooks/useGpuTier";
import { shouldEnablePostprocessing } from "./perf";
import type { Breakpoint } from "../../hooks/useBreakpoint";

/** Shared scene bloom. Lives inside the Canvas <Suspense> because useGpuTier()
 *  (drei useDetectGPU) suspends on first render. Bloom is dropped only on
 *  genuinely weak GPUs. Used by the home/decks scene Canvas (App.js) and the
 *  standalone deck hero Canvas (DeckHeroPage) so both render with identical
 *  light. */
export function PostprocessingLayer({ breakpoint }: { breakpoint: Breakpoint }) {
  const gpuTier = useGpuTier();
  if (!shouldEnablePostprocessing(breakpoint, gpuTier)) return null;
  return (
    <EffectComposer>
      <Bloom
        intensity={0.4}
        luminanceThreshold={0.95}
        luminanceSmoothing={0.2}
        mipmapBlur
      />
    </EffectComposer>
  );
}
